import { mapGetters, mapActions, mapState } from 'vuex'
import GlobalConst from '@/globals'

export default {
  props: [ 'userFormId', 'question', 'fieldType', 'listId', 'isClient', 'isEmpty' ],
  computed: {
    ...mapGetters('userform', {
      answerObject: 'answer',
      answerList: 'answerList',
    }),
    ...mapState('userform', [
      'formSubmissionAttempt'
    ]),
    answer () {
      return this.answerObject(this.question.id, this.fieldType.id, this.listId ? this.listId.id : null) || {}
    },
    valueChanged () {
      return this.value !== this.savedValue
    },
    statusIconClass () {
      if (this.answer.status === 'follow up') {
        return 'report_problem'
      } else {
        return 'check_circle'
      }
    },
    highlightNoAnswer () {
      if (Array.isArray(this.value))
        var checkValue = this.value.length == 0
      else
        var checkValue = !this.value && this.value !== 0
      return (checkValue && this.formSubmissionAttempt && this.isRequired)
    },
    isRequired () {
      if (this.question.is_list) {
        if (this.question.min_rows) {
          var answerLists = this.answerList(this.question.id)
          var nonEmptyCount = 0
          answerLists.forEach((list) => {
            var emptyAnswer = true
            this.question.fieldtype.subfieldtypes.forEach(subfield => {
              var answer = this.answerObject(this.question.id, subfield.id, list.id) || false
              if (answer && emptyAnswer) {
                emptyAnswer = GlobalConst.TestAnswerEmpty(answer, subfield)
              }
            })
            if (!emptyAnswer)
              nonEmptyCount += 1
          })
          return (nonEmptyCount < this.question.min_rows) || (this.fieldType.required && this.listId.id && !this.isEmpty)
        } else {
          return (this.fieldType.required && this.listId.id && !this.isEmpty)
        }
      } else {
        return (this.fieldType.required)
      }
    },
    optionListMaxLen () {
      if (this.question.fieldtype.options) {
        var tmp_count = 0
        this.question.fieldtype.options.forEach((opt) => {
          if (opt.text.length > tmp_count) {
            tmp_count = opt.text.length
          }
        })
        return tmp_count
      } else {
        return null
      }
    }
  },
  methods: {
    ...mapActions('userform', [
      'saveAnswer',
      'saveFileAnswer'
    ]),
    focus () {
      this.$emit('fieldFocused')
      this.savedValue = JSON.parse(JSON.stringify(this.value))
    },
    save () {
      this.$emit('fieldUnfocused')
      if (!this.valueChanged) return
      if (this.isClient) localStorage.setItem('lastQuestion:' + this.userFormId, `question-${this.question.id}`)
      this.failed = false
      return new Promise((resolve, reject) => {
        if (this.fieldType.atomic_type==='file') {
          const data = new FormData()
          for( var i = 0; i < this.value.length; i++ ){
            let file = this.value[i]
            data.append(`answer`, file)
          }
          if (this.value == '') {
            data.append('answer', '')
          }
          data.append("fieldtype_id", this.fieldType.id)
          data.append("list_id", this.listId ? (this.listId.id || '') : '')
          data.append("client_id", this.listId ? (this.listId.uuid || '') : '')
          data.append("question_id", this.question.id)
          var saveAction = this.saveFileAnswer({
            userFormId: this.userFormId,
            isClient: this.isClient,
            answerObject: data
          })
        } else {
          var saveAction = this.saveAnswer({
            userFormId: this.userFormId,
            questionId: this.question.id,
            fieldTypeId: this.fieldType.id,
            listId: this.listId ? (this.listId.id || null) : null,
            answer: this.value,
            isClient: this.isClient,
            uuid: this.listId ? (this.listId.uuid || null) : null
          })
        }
        saveAction.then(response => {
          this.failed = false
          this.savedValue = JSON.parse(JSON.stringify(this.value))
          if (this.listId && this.listId.uuid && response.answerlist_id) {
            this.$emit('update:listId', {id: response.answerlist_id, uuid: this.listId.uuid})
          }
          resolve()
        }).catch(error => {
          if (error && error.status === 401) {
            this.$store.state.userform.handleBypass = true
            window.onbeforeunload = null
            alert('You have been logged out due to inactivity.')
            this.$router.push({ name: 'Login', query: { from: this.$route.fullPath } })
            this.$store.state.userform.handleBypass = false
          } else if (error && error.status === 400) {
            reject()
          } else {
            this.failed = true
            reject()
          }
        })
      })
    },
    updateAnswer () {
      throw new Error('updateAnswer not implemented')
    }
  }
}
